export class UserOAuth {
  id: string;
  mail: string;
  displayName: string;
  givenName: string;
  surname: string;
  userPrincipalName: string;
  preferredLanguage: string;
  

  constructor(obj?: any) {
    if (obj) {
      this.id = obj.id;
      this.mail = obj.mail;
      this.displayName = obj.displayName;
      this.givenName = obj.givenName;
      this.surname = obj.surname;
      this.userPrincipalName = obj.userPrincipalName;
      this.preferredLanguage = obj.preferredLanguage;
      
    }
  }
}
